// extracted by mini-css-extract-plugin
export var accordion = "_i9-0";
export var chevron = "_i9-3";
export var closed = "_i9-2";
export var content = "_i9-4";
export var open = "_i9-1";
export var rotate = "_i9-5";